import { useEffect } from 'react';
import { useAppContext, SET_SHAPE, SET_BED_SIZE, SET_BED_CONFIG } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { MobileView, BrowserView } from 'react-device-detect';
import GardenBedButtons from '../components/GardenBedButtons';
import GardenBedEditorMobile from './GardenBedEditor.mobile';
import gardenBedLayouts from '../data/gardenBedLayouts.json';
import PreviewSVG from '../components/PreviewSVG';
import nextButton from '../images/ui_buttons/next_button.png';
import backButton from '../images/ui_buttons/back_button.png';

const GardenBedEditor = () => {
	const { state, dispatch } = useAppContext();
	const { shape, bedSize, style } = state.currentDesign || {};
	const navigate = useNavigate();

	// Navigate to the next screen
	const handleNext = () => {
		console.log(state);
		navigate('/choose-plants');
	};

	// Navigate to the previous screen
	const handleBack = () => {
		console.log(state);
		navigate('/sunlight');
	};

	// Logic for choosing selected garden bed shape
	const handleSelectGardenShape = (shapeId) => {
		dispatch({ type: SET_SHAPE, payload: shapeId });
	};

	// Logic for choosing selected garden bed size
	const handleSelectGardenSize = (sizeId) => {
		dispatch({ type: SET_BED_SIZE, payload: sizeId });
	};

	useEffect(() => {
		if (shape && bedSize && style) {
			console.log('Filtering in GardenBedEditor with: ', shape, bedSize, style);
			const filteredGardenBed = gardenBedLayouts.find(
				(layout) =>
					layout.shape === shape && layout.bedSize === bedSize && layout.style === style
			);
			console.log('Filtered garden bed layout:', filteredGardenBed);
			if (filteredGardenBed) {
				dispatch({ type: SET_BED_CONFIG, payload: filteredGardenBed.id });
				console.log('Dispatched bedConfig:', filteredGardenBed.id);
			} else {
				console.warn('No matching garden bed layout found.');
			}
		}
	}, [shape, bedSize, style, dispatch]);


	return (
		<>
			<MobileView>
				<GardenBedEditorMobile
					shape={shape}
					bedSize={bedSize}
					handleNext={handleNext}
					handleBack={handleBack}
					handleSelectGardenShape={handleSelectGardenShape}
					handleSelectGardenSize={handleSelectGardenSize}
				/>
			</MobileView>
			<BrowserView>
				<div className='full-container'>
					<header>
						<button onClick={handleBack}>
							<img src={backButton} alt='Back' className='button-image' />
						</button>
						<h1>Garden Bed</h1>
						<button onClick={handleNext}>
							<img src={nextButton} alt='Next' className='button-image' />
						</button>
					</header>
					<div className='garden-bed-body-container'>
						<div className='left-side-buttons-container'>
							<GardenBedButtons
								selectedShape={shape}
								selectedBedSize={bedSize}
							/>
						</div>
						<div className='full-svg-container'>
							<PreviewSVG />
						</div>
					</div>
				</div>
			</BrowserView>
		</>
	);
};

export default GardenBedEditor;
